var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"target":"_blank","href":_vm.googleAppStoreLink},on:{"click":function($event){return _vm.clickButton()}}},[_c('img',{attrs:{"alt":"Download Wotive gym workout tracker app android app store","src":require("../../assets/landing-page/googleplay.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }